module.exports = __webpack_public_path__ + "static/img/adv.ef1bc57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back/work/adv.png
// module id = mAN7
// module chunks = 1